// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1BXsh","range":"MonthRangeSwitch_range__2QWhq","disabled":"MonthRangeSwitch_disabled__Qlj8l"};